"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const config_1 = require("config");
const formatUpperCase_1 = __importDefault(require("./formatUpperCase"));
const mapTransactionTypeToProductType_1 = __importDefault(require("./mapTransactionTypeToProductType"));
function mapTransactionTypeandInstrumentTypeToProductType(transactionType, instrumentType) {
    if ((0, lodash_1.isNil)(transactionType) || (0, lodash_1.isNil)(instrumentType))
        return '';
    if ((0, formatUpperCase_1.default)(instrumentType).includes('INSTALLMENT')) {
        return config_1.PRODUCT_TYPE_MAP.installment;
    }
    const mappedProductType = (0, mapTransactionTypeToProductType_1.default)(transactionType);
    return mappedProductType ? mappedProductType : '';
}
exports.default = mapTransactionTypeandInstrumentTypeToProductType;
